import { createSlice } from '@reduxjs/toolkit';

import Storage from '../../services/Storage';

const userDetail = Storage.getUserDetail();
const hasUser = userDetail && Object.keys(userDetail).length > 0;

const initialState = {
  user: hasUser ? userDetail : null,
  userDetail: hasUser ? userDetail : null,
  isProfileUpdate: false,
};

const userSlice = createSlice({
  name: 'User',
  initialState,
  reducers: {
    setUserDetail: (state, action) => {
      // Handle both {type, user} (legacy) and {type, payload} (RTK) formats
      const userData = action.payload || action.user;
      state.user = userData;
      state.userDetail = userData;
    },
    setIsProfileUpdate: (state, action) => {
      state.isProfileUpdate = action.payload ?? action.isProfileUpdate;
    },
    logout: (state) => {
      state.user = null;
      state.userDetail = null;
    },
  },
  extraReducers: (builder) => {
    // Respond to legacy action types
    builder.addCase('SET_USER_DETAIL', (state, action) => {
      state.user = action.user;
      state.userDetail = action.user;
    });
    builder.addCase('IS_PROFILE_UPDATE', (state, action) => {
      state.isProfileUpdate = action.isProfileUpdate;
    });
  }
});

export const { setUserDetail, setIsProfileUpdate, logout } = userSlice.actions;
export default userSlice.reducer;
